// ----------------------------------------------------------------------------- //
//  Set Collapsible State
// ----------------------------------------------------------------------------- //
export default function setCollapsibleState( ref = document ) {

	const collapsible = ref.querySelectorAll('.js-collapsible');

	if ( collapsible.length ) {
		collapsible.forEach( (items) => {

			const itemToggle = items.querySelectorAll('.js-collapsible-toggle');

			if ( itemToggle.length ) {
				itemToggle.forEach( (btn) => {
					btn.addEventListener( "click", () => {

						const curItemId = btn.getAttribute("aria-controls");
						const curItemContent = ref.getElementById( curItemId );

						if ( btn.getAttribute("aria-expanded") == "false" ) {

							itemToggle.forEach( (e) => {

								const itemId = e.getAttribute("aria-controls");
								const itemContainer = ref.getElementById( itemId );

								if ( e.getAttribute("aria-expanded") == "true" && items.getAttribute("data-multiple") != "true" ) {
									e.setAttribute("aria-expanded", "false");
									itemContainer.setAttribute("aria-hidden", "true");
								}

								if ( e.getAttribute("aria-controls") == curItemId ) {
									e.setAttribute("aria-expanded", "true");
									curItemContent.setAttribute("aria-hidden", "false");
								}
							} )

						} else {

							if ( items.getAttribute("data-close") != "false" ) {
								itemToggle.forEach( (e) => {
									if ( e.getAttribute("aria-controls") == curItemId ) {
										e.setAttribute("aria-expanded", "false");
										curItemContent.setAttribute("aria-hidden", "true");
									}
								} )
							}
						}
					});
				});
			}
		});
	}
};
